var $cf2570d15af914ab$exports = {};
$cf2570d15af914ab$exports = {
    "help": `Pomoc`,
    "info": `Inform\xe1cie`
};


export {$cf2570d15af914ab$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
